import Vue from "vue";
import axios from "axios";

const localhttp = axios.create({
  baseURL: process.env.VUE_APP_API_BASEURL
});

localhttp.interceptors.request.use(async function(config) {
  config.headers.common["Authorization"] = "Bearer " + Vue.$keycloak.token;
  return config;
});

localhttp.defaults.headers.common = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
  Accept: "application/json, text/plain, */*",
  "Access-Control-Allow-Methods": "GET, PUT, POST, DELETE, OPTIONS",
  "Access-Control-Allow-Credentials": true
};

export { localhttp };
export default localhttp;
